export class NzTableData<TSearch, T> {
    sortField: string;
    pageSize = 10;
    pageIndex = 1;
    total = 0;
    search: TSearch;
    data: Array<T> = [];

    constructor(search: TSearch, sortField: string, pageSize: number = 10) {
        this.search = search;
        this.sortField = sortField;
        this.pageSize = pageSize;
    }

    setSort(sort: { key: string; value: string }): void {
        this.sortField = sort.key;
    }

    parseResponse(response: any) {
        this.total = response.total;
        this.data = response.data;
    }
}
